import { pageSizeConstants } from '../_constants/pageSize.constants';

const initialState = {
  pageSize: 10
};

export function pageSize(state = initialState, action) {
  switch (action.type) {
    case pageSizeConstants.SET_PAGESIZE:
      return {
        type: 'SET_PAGESIZE',
        pageSize: action.pageSize
      };
    default:
      return state
  }
}